export default "__VITE_ASSET__Cv9_4Lsh__"